import type {
  ListRepoCommitsParams,
  ListRepoPapersParams,
} from "@/features/repos/api/paperRepos";

export type RepoPapersSortField = "created_at" | "title" | "year" | "authors";
export type RepoPapersSortDir = "asc" | "desc";

export const paperReposListQueryKey = ["paper-repos", "list"] as const;

export const paperRepoDetailQueryKeyRoot = ["paper-repos", "detail"] as const;

export const paperRepoDetailQueryKey = (repoId: string | undefined) =>
  [...paperRepoDetailQueryKeyRoot, repoId] as const;

export const repoPapersListQueryKey = (
  repoId: string | undefined,
  params: ListRepoPapersParams,
) =>
  [
    "paper-repos",
    "papers",
    repoId,
    params.page ?? 1,
    params.per_page ?? 50,
    params.search ?? "",
    params.sort_by ?? "created_at",
    params.sort_dir ?? "desc",
    params.branch ?? "",
  ] as const;

export const repoCommitsQueryKey = (
  repoId: string | undefined,
  params: ListRepoCommitsParams,
) =>
  [
    "paper-repos",
    "commits",
    repoId,
    params.page ?? 1,
    params.per_page ?? 50,
    params.branch ?? "",
  ] as const;
